export type TTeeOnPaymentsView = "intro" | "activate" | "dashboard";

export type TTeeOnActivationStep = 1 | 2 | 3;

/** Countries where Tee On Payments / Stripe Connect is not offered yet. */
export const TEE_ON_PAYMENTS_UNSUPPORTED_COUNTRY_CODES = ["DO"] as const;

export function isTeeOnPaymentsSupported(countryCode?: string | null): boolean {
  if (!countryCode) {
    return true;
  }

  return !(TEE_ON_PAYMENTS_UNSUPPORTED_COUNTRY_CODES as readonly string[]).includes(countryCode.toUpperCase());
}

export interface IBusinessProfileForm {
  businessType: number | null;
  businessStructure: string;
  legalBusinessName: string;
  operatingName: string;
  registrationNumber: string;
  businessAddress: string;
  city: string;
  country: string;
  countryCode: string;
  province: string;
  provinceName: string;
  postalCode: string;
  phone: string;
  website: string;
}

export interface IPayoutAccountForm {
  currency: string;
  accountNumber: string;
  transitNumber: string;
  institutionNumber: string;
  routingNumber: string;
  isDefault: boolean;
}

export interface IRepresentativeForm {
  firstName: string;
  lastName: string;
  email: string;
  relationshipType: "director" | "executive" | "owner" | "representative";
  dateOfBirth: Date | null;
  homeAddress: string;
  city: string;
  country: string;
  province: string;
  county: string;
  postalCode: string;
  phoneNumber: string;
  sin: string;
  ssn: string;
  status: string;
}

export interface IProcessingFee {
  id: number;
  facility_id: number;
  currency: string;
  online_credit_rate: number;
  online_premium_rate: number;
  online_interac_rate: number;
  online_credit_amount: number;
  online_interac_amount: number;
  in_person_credit_rate: number;
  in_person_credit_amount: number;
  in_person_interac_rate: number;
  in_person_premium_rate: number;
  in_person_premium_amount: number;
  online_premium_amount: number;
  in_person_interac_amount: number;
  international_rate: number;
  premium_card_rate: number;
}
